import { useSwaggerlessContext } from 'Context/SwaggerlessContext';
import React, { useEffect, useState } from 'react';
import closeModal from 'Helpers/ModalHelper';
import Drawer from 'Components/Ant/Drawer';
import Currency from 'Components/Format/Currency';
import { properCase } from 'Helpers/Formats';
import { fromAPIResponse, percentEquity, sumBalance } from 'Classes/Account';
import './index.css';
import { displayErrorMessage } from 'Helpers/FacetNotificationManager';
import { Link } from 'react-router-dom';
import { householdInvestmentAssetsUri } from 'Consts/advisorUris';
import { PersonalRetirementAccounts } from 'Consts/Questionnaire';
import useSimpleHousehold from 'Hooks/useSimpleHousehold';
import { householdInvestmentAssetsUriClient } from 'Consts/clientUris';
import useUserContext from 'Context/UserContext';

// assuming the format comes in as <company name>-<fund name>-<equity percent | 'Cash'>
const formatFundName = (name) => {
  let formattedName = name;
  formattedName = formattedName.replace(/-/g, ' ');
  formattedName = formattedName.replace(' ', ' - ');
  if (formattedName.match(/[0-9]$/)) {
    formattedName += '%';
  }
  return formattedName;
};

const renderAccount = (account) => {
  let balance = Number.parseFloat(account.balance);
  if (!balance) {
    balance = 0;
  }
  const equity = percentEquity(account);
  const fixed = equity !== null ? 100 - equity : null;
  return (
    <div key={account.id}>
      <hr />
      <div>{properCase(account.name ? account.name : account.type)}</div>
      {account.facetModel ? (
        <div>{formatFundName(account.facetModel)}</div>
      ) : (
        ''
      )}
      <div className="d-flex flex-row">
        <Currency
          amount={balance}
          className="flex-grow-1 color-facet-green thin currency"
        />
        <div className="flex-column px-3 color-blue font-weight-bold">
          <div>Equity:</div>
          <div>{equity}</div>
        </div>
        <div className="flex-column px-3 color-light-blue font-weight-bold">
          <div>Fixed:</div>
          <div>{fixed}</div>
        </div>
      </div>
    </div>
  );
};

const ManagedAccountsModal = () => {
  const { getAccounts } = useSwaggerlessContext();
  const { householdId } = useSimpleHousehold();

  const [aum, setAUM] = useState(0);
  const [accounts, setAccounts] = useState([]);
  const [lastUpdated, setLastUpdated] = useState('');
  const { isAgent } = useUserContext();

  const getHouseholdInvestmentsUri = () => {
    if (isAgent) {
      return householdInvestmentAssetsUri(householdId, PersonalRetirementAccounts);
    }

    return householdInvestmentAssetsUriClient(householdId, PersonalRetirementAccounts);
  };
  useEffect(() => {
    getAccounts(householdId, {}, { isManaged: true })
      .then((res) => {
        const accts = res.data.map(acct => fromAPIResponse(acct));
        setAccounts(accts);

        setAUM(sumBalance(accts));

        let lastSync = '';
        if (accts.length > 0 && accts[0].lastSync.isValid()) {
          lastSync = accts[0].lastSync.format('M/D/YY');
        }
        setLastUpdated(lastSync);
      })
      .catch(err => displayErrorMessage(err, 'Failed to retrieve accounts'));
  }, []);
  return (
    <Drawer
      className="managed-accounts-flyout"
      visible
      width={500}
      onClose={closeModal}
    >
      <div className="assets-under-management">
        <h4 className="title">Assets Under Management</h4>
        <div className="row-wrap">
          <span className={aum >= 0 ? 'total-positive' : 'total-negative'}>
            <Currency amount={aum} />
          </span>
        </div>
        <div className="last-updated">Last updated {lastUpdated}</div>
      </div>
      {accounts.map(account => renderAccount(account))}
      <hr />
      <Link
        className="pill"
        to={getHouseholdInvestmentsUri()}
      >
        See in Questionnaire &gt;
      </Link>
    </Drawer>
  );
};
ManagedAccountsModal.propTypes = {
};

export default ManagedAccountsModal;
